import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPause = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 60 60"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#pause_svg__a)">
      <circle cx={30} cy={30} r={28.5} stroke="currentColor" strokeWidth={3} />
      <path fill="currentColor" d="M21 19h7v21.65h-7zM31 19h7v21.65h-7z" />
    </g>
    <defs>
      <clipPath id="pause_svg__a">
        <path fill="currentColor" d="M0 0h60v60H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPause;
